import {apiSlice} from '../apiSlice';

const COMPANY_URL = '/companies';

export const companyApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getCompany: builder.query({
            query: (data) => ({
                url: `${COMPANY_URL}`,
                method: 'GET',
                headers: {
                    "x-access-token": data
                }
            }),
        }),
    }),
});

export const {
    useGetCompanyQuery,
} = companyApiSlice;
